<template>
<div>
  <SubscribeList></SubscribeList>
</div>
</template>

<script>
import SubscribeList from "@/components/SubscribeList";
export default {
  name: "subscribe",
  components: {SubscribeList},
}
</script>

<style scoped>

</style>